<div id="lista" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
             fxLayout="column" fxLayoutAlign="center center"
             fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

            <!-- TÍTULO E BOTÕES ALINHADOS -->
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
                <!-- TÍTULO -->
                <div class="logo mb-24 mb-md-0"
                     fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="logo-icon s-32 mr-16">
                        business
                    </mat-icon>
                    <span class="logo-text h1">
                        Histórico de Operações
                    </span>
                </div>
                <!-- / TÍTULO -->

                <!-- BOTÕES DE AÇÃO -->
                <div fxLayout="row" fxLayoutAlign="start center" style="margin-left: 16px; gap: 8px;">
                    <!-- Botão Consultar -->
                    <button mat-mini-fab
                            color="accent"
                            matTooltip="Consultar Operações"
                            (click)="openFiltro()">
                        <mat-icon>search</mat-icon>
                    </button>

                    <!-- Botão Exportar -->
                    <button mat-mini-fab
                            color="accent"
                            matTooltip="Exportar Operações"
                            (click)="getAllExport()">
                        <mat-icon>cloud_download</mat-icon>
                    </button>

                    <!-- Botão Importar (condicional) -->
                    <button mat-mini-fab
                            color="accent"
                            matTooltip="Importar Operações"
                            (click)="openCadastro()"
                            *ngIf="this.user.role_id == 2 || user.tipo_usuario_id == 2">
                        <mat-icon>cloud_upload</mat-icon>
                    </button>
                </div>
                <!-- / BOTÕES DE AÇÃO -->
            </div>
            <!-- / TÍTULO E BOTÕES ALINHADOS -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">    
            <ngx-datatable 
                #table 
                class='material striped' 
                [loadingIndicator]="loadingIndicator"
                [columns]="columns" 
                [columnMode]="'force'" 
                [headerHeight]="50"                       
                [footerHeight]="50" 
                [rowHeight]="'auto'" 
                [rows]='rows'
                [limit]="params.per_page"                        
                (sort)="onSort($event)">


                <ngx-datatable-column name="Data" prop="created_at" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-created_at="value" ngx-datatable-cell-template>
                        {{created_at | date:'dd/MM/yyyy'}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Ativo" prop="sigla_ativo" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <span  
                            (click)="alterarCotacao(row.ativo_id)"
                            matTooltip="Clique aqui para alterar o valor da cotação atual"                             
                            style="padding: 5px; border-radius: 10px;cursor: pointer" 
                            [className]="row.cor_hexadecimal">
                            <b>{{row.sigla_ativo}}</b>
                        </span>
                    </ng-template>
                </ngx-datatable-column>
                

                <ngx-datatable-column name="Cliente" prop="cliente" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template style="width: 200px;">
                        {{row.conta_cliente}} - {{row.nome_cliente}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Operação" prop="tipo" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <span 
                        [ngClass]="{
                            'negativo':row.tipo == 'V',
                            'positivo': row.tipo == 'C'}
                        ">
                            {{getOperacao(row) }}
                        </span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Tipo" prop="tipo_ativo" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <span
                            matTooltip= "Ações, BDRs, ETDs, FIIs e Units"
                            [matTooltipDisabled]="row.tipo_ativo.trim() != 'B'"
                        >
                            {{ getTipoAtivo(row) }}
                        </span>           
                    </ng-template>
                </ngx-datatable-column>
              

                <ngx-datatable-column name="Qtd. Exec" prop="qtd_executado" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{  row.tipo.trim() != 'D' ? (row.qtd_executado | number : '1.0-0') : '--' }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Preço (R$)" prop="preco_executado" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{ row.tipo.trim() != 'E' && row.tipo.trim() != 'D' ? (row.preco_executado | number : '1.2-2') : '--'}}             
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Volume Inicial (R$)" prop="vlr_executado" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <span                             
                            [ngClass]="{
                                'negativo': row.tipo.trim() === 'C' , 
                                'positivo': row.tipo.trim() === 'V'
                            }"
                        >
                            {{row.vlr_executado | number : '1.2-2'}} 
                        </span>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator 
                    #paginator 
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)"
                >
                </mat-paginator>
            </div>          
        </div>
    </div>
</div>